<form [formGroup]="userForm" novalidate>
  <input type="hidden" formControlName="id" />
  <div class="twoColumnLayout">
    <div class="column">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>Name and Email</mat-card-title>
        </mat-card-header>
        <!-- User Info Content -->
        <mat-card-content class="mat-elevation-z3">
          <!-- Email -->
          <mat-form-field class="full-width-input">
            <mat-label>Email</mat-label>
            <input matInput type="text" formControlName="email" />
            <app-error-display
              [form]="userForm"
              controlName="email"></app-error-display>
          </mat-form-field>
          <!-- Name -->
          <mat-form-field class="full-width-input">
            <mat-label>First Name</mat-label>
            <input matInput type="text" formControlName="firstName" />
            <app-error-display
              [form]="userForm"
              controlName="firstName"></app-error-display>
          </mat-form-field>
          <!-- Name -->
          <mat-form-field class="full-width-input">
            <mat-label>Last Name</mat-label>
            <input matInput type="text" formControlName="lastName" />
            <app-error-display
              [form]="userForm"
              controlName="lastName"></app-error-display>
          </mat-form-field>
          <button
            mat-flat-button
            (click)="setPassword()"
            class="secondary-button"
            options-id="SET_PASSWORD"
            [option]="user.id">
            <fa-icon [icon]="['fas','key']"></fa-icon>
            Set Password
          </button>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="column">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>School Preferences</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mat-elevation-z3">
          <div class="user-school-selections">
            <!-- School Group -->
            <mat-form-field class="full-width-input">
              <mat-label>School Group</mat-label>
              <input type="text" matInput formControlName="schoolGroupId" [matAutocomplete]="auto">
              <mat-icon matSuffix class="icon" *ngIf="!userForm.get('schoolGroupId').value">arrow_drop_down</mat-icon>
              <button
                matSuffix
                class="icon"
                *ngIf="userForm.get('schoolGroupId').value"
                mat-icon-button
                aria-label="Clear"
                (click)="clearSchoolSettings()"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'schoolGroupOptions')" showPanel="true" (optionSelected)="updateSchoolOptions($event)">
                <mat-option *ngFor="let option of filteredSchoolGroupOptions | async" [value]="option.value">
                  {{option.display}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- School -->
            <mat-form-field class="full-width-input">
              <mat-label>School</mat-label>
              <input type="text" matInput formControlName="currentSchoolId" [matAutocomplete]="autoSchools">
              <mat-icon matSuffix class="icon" *ngIf="!userForm.get('currentSchoolId').value">arrow_drop_down</mat-icon>
              <button
                matSuffix
                class="icon"
                *ngIf="userForm.get('currentSchoolId').value"
                mat-icon-button
                aria-label="Clear"
                (click)="clearSchoolSettings(false)"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete #autoSchools="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'schoolOptions')" showPanel="true">
                <mat-option *ngFor="let option of filteredSchoolOptions | async" [value]="option.value">
                  {{option.display}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <button
            *ngIf="currentUser.type === UserTypeEnum.INTERNAL_ADMIN || currentUser.type === UserTypeEnum.GROUP_ADMIN"
            mat-flat-button
            class="secondary-button"
            (click)="clearSchoolSettings()">
            Clear School Settings
          </button>
        </mat-card-content>
      </mat-card>
      <mat-card appearance="outlined">
        <!-- User Info -->
        <mat-card-header>
          <mat-card-title>Contact Information</mat-card-title>
        </mat-card-header>
        <mat-card-content class="mat-elevation-z3">
          <!-- Contact Info Header -->
          <!-- Contact Info Content -->
          <div class="report-content-form">
            <!-- Address -->
            <mat-form-field class="full-width-input">
              <mat-label>Address</mat-label>
              <input matInput type="text" formControlName="address" />
              <app-error-display
                [form]="userForm"
                controlName="address"></app-error-display>
            </mat-form-field>
            <!-- State -->
            <mat-form-field class="full-width-input">
              <mat-label>State</mat-label>
              <input type="text" matInput formControlName="state" [matAutocomplete]="autoStates">
              <mat-icon matSuffix class="icon">arrow_drop_down</mat-icon>
              <mat-autocomplete #autoStates="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'stateOptions')" showPanel="true">
                <mat-option *ngFor="let option of filteredStateOptions | async" [value]="option.value">
                  {{option.display}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!-- City -->
            <mat-form-field class="full-width-input">
              <mat-label>City</mat-label>
              <input matInput type="text" formControlName="city" />
              <app-error-display
                [form]="userForm"
                controlName="city"></app-error-display>
            </mat-form-field>
            <!-- Zip -->
            <mat-form-field class="full-width-input">
              <mat-label> Zip</mat-label>
              <input matInput type="text" formControlName="zip" />
              <app-error-display
                [form]="userForm"
                controlName="zip"></app-error-display>
            </mat-form-field>
            <!-- Phone -->
            <mat-form-field class="full-width-input">
              <mat-label> Phone</mat-label>
              <input matInput type="text" formControlName="phone" />
              <app-error-display
                [form]="userForm"
                controlName="phone"></app-error-display>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</form>
